import React from 'react';
import { StatusType } from '.';

type StatusContextProps = {
  status?: StatusType | null;
  ariaLabelledBy?: string | null;
  ariaDescribedBy?: string | null;
};

// TODO: separate ariaLabelledBy from StatusContext, since it's not related to status or reflect expanded StatusContext responsibilities by renaming
export const StatusContext = React.createContext<StatusContextProps>({
  status: null,
  ariaLabelledBy: null,
  ariaDescribedBy: null,
});

export const getStatusFromContext = (
  { status }: StatusContextProps,
  propsStatus: string,
) => propsStatus || status;

export const getAriaAttributesFromContext = ({
  ariaLabelledBy,
  ariaDescribedBy,
}: StatusContextProps) => ({
  ...(ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }),
  ...(ariaDescribedBy && { 'aria-describedby': ariaDescribedBy }),
});
